import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Pup silhouette uses the ★1 tier art. The active rendering for
// Pebble Pup goes through TIERED_GLYPHS (see tieredGlyphs.ts) which
// routes ★2/★3 to the richer tier images extracted from
// assets/pebble_pup_3tier.jpg.
export const Pup = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/pup-1.png" size={size} alt="pup" />
)
